import { render, staticRenderFns } from "./gc-record-cell.vue?vue&type=template&id=3ab32939&scoped=true"
import script from "./gc-record-cell.vue?vue&type=script&lang=js"
export * from "./gc-record-cell.vue?vue&type=script&lang=js"
import style0 from "./gc-record-cell.vue?vue&type=style&index=0&id=3ab32939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab32939",
  null
  
)

export default component.exports